module.exports = __webpack_public_path__ + "static/media/mobile_farm_map.4772c7fa.png";